import React from 'react';
import { connect } from 'react-redux';

import * as reservationActions from '../../../redux/reservations/actions';
import * as menuItemsActions from '../../../redux/menuItems/actions';
import * as invoicesActions from '../../../redux/invoices/actions';

import Spin from '../../../components/loading';
import submitForm from '../../../utils/submitForm';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

import IncomingReservesListFilter from './Filter';
import InvoiceDetailsModal from '../modals/InvoiceDetails';
import ReserveDetailsModal from '../modals/ReserveDetails';
import Table from '../../../components/table';
import { incomingColumns } from '../../../enums/columns/reservation';

class IncomingReservesList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      itemsPerPage: 20,
      query: '',
      sortType: 'asc',
      sortBy: 'createdAt',
      errorText: locales('errors.default'),
      errorFlag: false,
    };
  }

  componentDidMount() {
    if (this.state.query !== '') {
      this.sortTable(this.state.query);
    } else {
      this.sortTable(this.state.sortBy);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.updateSocketReserve !== this.props.updateSocketReserve ||
      prevState.currentPage !== this.state.currentPage ||
      prevState.query !== this.state.query
    ) {
      const query = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.actions.fetchAllIncomingReservations(query);
    }
  }

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = currentPage => {
    this.setState({ currentPage });
  };

  applyFilters = event => {
    const queryString = submitForm(event);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) {
      query = `${filter}&${sort}`;
    } else if (filter) {
      query = `${filter}`;
    } else if (sort) {
      query = `${sort}`;
    }
    this.setState({ query, currentPage: 1 });
  };

  sortTable = query => {
    this.setState(
      { sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' },
      () => {
        query = `${query}-${this.state.sortType}`;
        this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
      },
    );
  };

  closeInvoiceModal = isFetchSuccess => {
    if (isFetchSuccess) {
      this.setState({
        invoiceModalIsOpen: false,
      });
    } else {
      this.setState(() => ({
        invoiceModalIsOpen: false,
      }));
    }
  };

  displayInvoiceModal = reserveId => {
    this.setState(() => ({
      invoiceModalIsOpen: true,
      selectedReserveId: reserveId,
    }));
  };

  getInvoiceDataByReserveId = reserveId => {
    this.props.actions.fetchReservationInvoiceDetails(reserveId);
  };

  getReservationTemporaryPrint = (reserveId, printMode) => {
    this.props.actions.getReservationTemporaryPrint(reserveId, printMode);
  };

  getMyCafeMenuItems = () => {
    this.props.actions.fetchAllMenuItems('pageNumber=1&pageSize=10000'); // TODO
  };

  displayReserveDetailsModal = id => {
    const selectedReserve = this.props.incomingReservationsList.find(
      reserve => reserve.id == id,
    );

    if (selectedReserve) {
      this.setState(() => ({
        reserveDetailsModalIsOpen: true,
        selectedReserveId: selectedReserve.id,
      }));
    }
  };

  closeReserveDetailsModal = (isFetchSuccess = false) => {
    if (isFetchSuccess) {
      const searchQuery = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.actions.fetchAllIncomingReservations(searchQuery).then(() => {
        this.setState(() => ({
          reserveDetailsModalIsOpen: false,
        }));
      });
    } else {
      this.setState(() => ({
        reserveDetailsModalIsOpen: false,
      }));
    }
  };

  render() {
    const { loading, message, failed, error, totalRecords } = this.props;

    return (
      <Spin spinning={loading}>
        <section className='page-header'>
          <h1>{locales('titles.incomingReservations')}</h1>
        </section>

        {this.state.errorFlag && this.handleAlert()}
        {error && (
          <div className='alert alert-danger'>
            {locales('messages.server.error')}
          </div>
        )}
        {failed && <div className='alert alert-danger'>{message}</div>}

        <section className='panel panel-default'>
          <div className='panel-heading'>
            <i className='fas fa-list-alt px-1' />
            {locales('titles.incoming.reservations.list')}
          </div>

          <div className='panel-body'>
            <IncomingReservesListFilter
              applyFilters={this.applyFilters}
              filterAndSort={this.filterAndSort}
            />

            <Table
              columns={incomingColumns}
              dataSource={this.props.incomingReservationsList}
              loading={loading}
              action={{
                displayReserveDetailsModal: this.displayReserveDetailsModal,
                // displayInvoiceModal: this.displayInvoiceModal,
              }}
              sort={{ type: this.state.sortType, action: this.sortTable }}
              pagination={{
                currentPage: this.state.currentPage,
                pageSize: this.state.itemsPerPage,
                totalCount: totalRecords,
                onPageChange: this.onPageChanged,
              }}
            />
          </div>
        </section>

        {this.state.reserveDetailsModalIsOpen && (
          <ReserveDetailsModal
            isOpen={this.state.reserveDetailsModalIsOpen}
            reserveId={this.state.selectedReserveId}
            close={this.closeReserveDetailsModal}
          />
        )}

        {this.state.invoiceModalIsOpen && (
          <InvoiceDetailsModal
            isOpen={this.state.invoiceModalIsOpen}
            close={this.closeInvoiceModal}
            getInvoiceDataByReserveId={this.getInvoiceDataByReserveId}
            getMyCafeMenuItems={this.getMyCafeMenuItems}
            getReservationTemporaryPrint={this.getReservationTemporaryPrint}
            getReservationFactorPrint={
              this.props.actions.getReservationFactorPrint
            }
            getReservationTemporaryPrintByPrinterTarget={
              this.props.actions.getReservationTemporaryPrintByPrinterTarget
            }
            temproraySave={this.props.actions.temproraySaveInvoice}
            finalSave={this.props.actions.finalSaveInvoice}
            invoiceData={this.props.reservationInvoiceDetails}
            fetchDataLoading={this.props.reservationInvoiceDetailsLoading}
            fetchDataMessage={this.props.reservationInvoiceDetailsMessage}
            fetchDataFailed={this.props.reservationInvoiceDetailsFailed}
            fetchDataError={this.props.reservationInvoiceDetailsError}
            menuItemsList={this.props.menuItemsList}
            getMenuItemsLoading={this.props.getMenuItemsLoading}
            getMenuItemsMessage={this.props.getMenuItemsMessage}
            getMenuItemsFailed={this.props.getMenuItemsFailed}
            getMenuItemsError={this.props.getMenuItemsError}
            reservationTemporaryReceipt={this.props.reservationTemporaryReceipt}
            reservationFactorPrint={this.props.reservationFactorPrint}
            temporarySaveLoading={this.props.temporarySaveInoviceItemsLoading}
            temporarySaveFailed={this.props.temporarySaveInoviceItemsFailed}
            temporarySaveError={this.props.temporarySaveInoviceItemsError}
            temporarySaveMessage={this.props.temporarySaveInoviceItemsMessage}
            finalSaveLoading={this.props.finalSaveInoviceItemsLoading}
            finalSaveFailed={this.props.finalSaveInoviceItemsFailed}
            finalSaveError={this.props.finalSaveInoviceItemsError}
            finalSaveMessage={this.props.finalSaveInoviceItemsMessage}
            reserveId={this.state.selectedReserveId}
            cafeName={this.props.reservationInvoiceDetails.cafeName}
            invoiceId={this.props.reservationInvoiceDetails.id}
            invoiceNo={this.props.reservationInvoiceDetails.num}
            customerFullName={
              this.props.reservationInvoiceDetails.customerFullName
            }
            customerMobileNumber={
              this.props.reservationInvoiceDetails.customerMobileNumber
            }
            individualsCount={
              this.props.reservationInvoiceDetails.reservePersons
            }
            tablesNum={this.props.reservationInvoiceDetails.reservedTables}
            meal={this.props.reservationInvoiceDetails.reserveMeal}
            reserveDate={this.props.reservationInvoiceDetails.reserveDate}
            reserveStartAt={this.props.reservationInvoiceDetails.reserveStartAt}
            reserveEndAt={this.props.reservationInvoiceDetails.reserveEndAt}
            reserveStatus={this.props.reservationInvoiceDetails.reserveStatus}
            invoiceStatus={this.props.reservationInvoiceDetails.invoiceStatus}
            trackingNumber={
              this.props.reservationInvoiceDetails.reserveTrackingNumber
            }
            reserveType={this.props.reservationInvoiceDetails.reserveType} // TODO
            subTotalPrice={this.props.reservationInvoiceDetails.subTotalPrice}
            toBePaidToCafePrice={
              this.props.reservationInvoiceDetails.toBePaidToCafePrice
            }
            hourlyDiscountAmount={
              this.props.reservationInvoiceDetails.hourlyDiscountsAmount
            }
            hourlyDiscountPercent={
              this.props.reservationInvoiceDetails.hourlyDiscountPercent
            }
            discountCodeAmount={
              this.props.reservationInvoiceDetails.discountCodeAmount
            }
            discountCodePercent={
              this.props.reservationInvoiceDetails.discountCodePercent
            } // TODO
            totalPrice={this.props.reservationInvoiceDetails.totalPrice}
            reserveBaseCost={
              this.props.reservationInvoiceDetails.reserveBaseCost
            }
            currency={this.props.reservationInvoiceDetails.currency} // TODO
            invoiceAdditions={
              this.props.reservationInvoiceDetails.invoiceAdditions
            } // TODO
            totalEntranceAmount={
              this.props.reservationInvoiceDetails.totalEntranceAmount
            }
            invoiceAdditionsAmount={
              this.props.reservationInvoiceDetails.invoiceAdditionsAmount
            } // TODO
            invoiceItems={this.props.reservationInvoiceDetails.invoiceItems} // TODO
            menuItems={this.props.reservationInvoiceDetails.menuItems} // TODO
            notes={this.props.reservationInvoiceDetails.notes}
            rseePercent={this.props.reservationInvoiceDetails.rseePercent}
            rseeStockAmount={
              this.props.reservationInvoiceDetails.rseeStockAmount
            }
            balanceAmount={this.props.reservationInvoiceDetails.balanceAmount}
            invoiceDiscountCodeAmount={
              this.props.reservationInvoiceDetails.invoiceDiscountCodeAmount
            }
          />
        )}
      </Spin>
    );
  }
}

const mapStateToProps = state => {
  return {
    incomingReservationsList:
      state.reservationsReducer.incomingReservationsList,
    // incomingReservations: state.reservationsReducer.incomingReservations,
    totalRecords: state.reservationsReducer.incomingReservationsTotalRecords,
    loading: state.reservationsReducer.incomingReservationsLoading,
    message: state.reservationsReducer.incomingReservationsMessage,
    failed: state.reservationsReducer.incomingReservationsFailed,
    error: state.reservationsReducer.incomingReservationsError,

    reservationInvoiceDetails:
      state.reservationsReducer.reservationInvoiceDetails,
    reservationInvoiceDetailsLoading:
      state.reservationsReducer.reservationInvoiceDetailsLoading,
    reservationInvoiceDetailsMessage:
      state.reservationsReducer.reservationInvoiceDetailsMessage,
    reservationInvoiceDetailsFailed:
      state.reservationsReducer.reservationInvoiceDetailsFailed,
    reservationInvoiceDetailsError:
      state.reservationsReducer.reservationInvoiceDetailsError,

    menuItemsList: state.menuItemsReducer.menuItemsList,
    getMenuItemsLoading: state.menuItemsReducer.menuItemLoading,
    getMenuItemsMessage: state.menuItemsReducer.menuItemMessage,
    getMenuItemsFailed: state.menuItemsReducer.menuItemFailed,
    getMenuItemsError: state.menuItemsReducer.menuItemError,

    temporarySaveInoviceItemsLoading:
      state.reservationsReducer.temporarySaveInoviceItemsLoading,
    temporarySaveInoviceItemsFailed:
      state.reservationsReducer.temporarySaveInoviceItemsFailed,
    temporarySaveInoviceItemsError:
      state.reservationsReducer.temporarySaveInoviceItemsError,
    temporarySaveInoviceItemsMessage:
      state.reservationsReducer.temporarySaveInoviceItemsMessage,

    finalSaveInoviceItemsLoading:
      state.reservationsReducer.finalSaveInoviceItemsLoading,
    finalSaveInoviceItemsFailed:
      state.reservationsReducer.finalSaveInoviceItemsFailed,
    finalSaveInoviceItemsError:
      state.reservationsReducer.finalSaveInoviceItemsError,
    finalSaveInoviceItemsMessage:
      state.reservationsReducer.finalSaveInoviceItemsMessage,

    reservationTemporaryReceipt:
      state.reservationsReducer.reservationTemporaryReceipt,
    reservationFactorPrint: state.reservationsReducer.reservationFactorPrint,
    updateSocketReserve: state.notificationsReducer.updateSocketReserve,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      fetchAllIncomingReservations: query =>
        dispatch(reservationActions.fetchAllIncomingReservations(query)),
      fetchReservationInvoiceDetails: reserveId =>
        dispatch(reservationActions.fetchReservationInvoiceDetails(reserveId)),
      fetchAllMenuItems: query =>
        dispatch(menuItemsActions.fetchAllMenuItems(query)),
      temproraySaveInvoice: (invoiceId, invoiceItems) =>
        dispatch(invoicesActions.temproraySaveInvoice(invoiceId, invoiceItems)),
      finalSaveInvoice: (invoiceId, invoiceItems) =>
        dispatch(invoicesActions.finalSaveInvoice(invoiceId, invoiceItems)),
      getReservationTemporaryPrint: (reserveId, printMode) =>
        dispatch(reservationActions.fetchReservationTemporaryPrint(reserveId, printMode)),
      getReservationFactorPrint: reserveId =>
        dispatch(reservationActions.fetchReservationFactorPrint(reserveId)),
      getReservationTemporaryPrintByPrinterTarget: (reserveId, printerTarget) =>
        dispatch(
          reservationActions.fetchReservationTemporaryPrintByPrinterTarget(
            reserveId,
            printerTarget,
          ),
        ),
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IncomingReservesList);
